export const AUTO_RELOAD_DELAY_MS = 2500;

/** Stale-deploy chunk-load failures — new build shipped, old tab still
 *  holding hashed asset URLs that 404. Native engine messages (Firefox
 *  `_result is undefined`, Chrome `undefined (reading 'default')`) are the same miss
 *  after Vite's preload wrapper resolves `undefined` instead of rejecting. */
const CHUNK_LOAD_ERROR_PATTERN =
  /failed to fetch dynamically imported module|error loading dynamically imported module|importing a module script failed|loading chunk .* failed|loading css chunk .* failed|is not a valid javascript mime type|failed to load module script|unable to preload css|_result\.default|_result is undefined|undefined \(reading ['"]?default['"]?\)/i;

export function isChunkLoadError(error: unknown): boolean {
  if (!(error instanceof Error)) return false;
  if (error.name === 'ChunkLoadError') return true;
  if (CHUNK_LOAD_ERROR_PATTERN.test(error.message)) return true;
  const cause = (error as { cause?: unknown }).cause;
  if (cause instanceof Error) {
    if (cause.name === 'ChunkLoadError') return true;
    if (CHUNK_LOAD_ERROR_PATTERN.test(cause.message)) return true;
  }
  return false;
}

export function prefersReducedMotion(): boolean {
  return (
    typeof window !== 'undefined' &&
    typeof window.matchMedia === 'function' &&
    window.matchMedia('(prefers-reduced-motion: reduce)').matches
  );
}
